var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig } from "@jti/fe-common";
import { getUser } from "../../utils";
import { CasBaseApi } from "./CasBaseApi";
import { EndpointPlaceholders, Endpoints, EvoEndpoints } from "./CasEndpoints";
export class CasInvoiceApi extends CasBaseApi {
    constructor(baseUrl, tenantToken, ciamToken, userUuid) {
        super(baseUrl, tenantToken, ciamToken, userUuid);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.name = "CasInvoiceApi";
    }
    static init() {
        const config = getConfig();
        const user = getUser();
        return new CasInvoiceApi(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token, user.uuid || "");
    }
    replaceUuid(path) {
        return path.replace(EndpointPlaceholders.UUID, this.userUuid);
    }
    getInvoicePdf(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const invoicePath = this.isEvo ? EvoEndpoints.InvoicePath : Endpoints.InvoicePath;
            return this.request(`${this.replaceUuid(invoicePath)}/${id}/invoice/`, {
                method: "GET",
            }, true);
        });
    }
}
//# sourceMappingURL=CasInvoiceApi.js.map